const CACHE_NAME = 'coamana-v1';

export async function clearApiPaths(paths) {
    if (!('caches' in window)) return;
    try {
        const cache = await caches.open(CACHE_NAME);
        const keys = await cache.keys();
        await Promise.all(
            keys
                .filter(r => paths.some(p => new URL(r.url).pathname.startsWith(p)))
                .map(r => cache.delete(r))
        );
    } catch {
    }
}

export async function clearAllApiCache() {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({type: 'CLEAR_API_CACHE'});
    }
    if (!('caches' in window)) return;
    try {
        const cache = await caches.open(CACHE_NAME);
        const keys = await cache.keys();
        await Promise.all(
            keys
                .filter(r => new URL(r.url).pathname.startsWith('/api/'))
                .map(r => cache.delete(r))
        );
    } catch {
    }
}
